export default {
    title: 'Тип предписания',
    placeholder: '-',
};
